import { render, staticRenderFns } from "./InfoListView.vue?vue&type=template&id=3f0bc530&scoped=true&"
import script from "./InfoListView.vue?vue&type=script&lang=js&"
export * from "./InfoListView.vue?vue&type=script&lang=js&"
import style0 from "./InfoListView.vue?vue&type=style&index=0&id=3f0bc530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0bc530",
  null
  
)

export default component.exports